import { render, staticRenderFns } from "./ClientName.vue?vue&type=template&id=37569316&scoped=true"
import script from "./ClientName.vue?vue&type=script&lang=js"
export * from "./ClientName.vue?vue&type=script&lang=js"
import style0 from "./ClientName.vue?vue&type=style&index=0&id=37569316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37569316",
  null
  
)

export default component.exports